import RectangleButton from '@/components/molecules/rectangleButton'
import Container from '@/components/templates/container'
import Title from './title'
import Description from './description'
import MainImage from './mainImage'
import { useMediaQuery } from '@mui/material'

const Membership = ({ title, description, image, ctaButton }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const base =
    'relative w-full flex flex-col lg:flex-row justify-between gap-x-mediumDesktop mb-largeMobile lg:mb-largeDesktop'
  const baseContent = 'relative w-full max-w-[660px]'
  const baseButton = 'block mt-smallMobile lg:mt-mediumDesktop mx-auto lg:mx-0'

  return (
    <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
      <div className={base}>
        {!isDesktop && <Title text={title} />}
        <MainImage image={image} />
        <div className={baseContent}>
          {isDesktop && <Title text={title} />}
          <Description text={description} />
          <RectangleButton
            name={ctaButton.name}
            link={ctaButton.link}
            target="_blank"
            className={baseButton}
          />
        </div>
      </div>
    </Container>
  )
}

export default Membership
